import { Outlet } from "react-router-dom";

/**
 * Layout for authentication pages (login, register, etc.)
 * No sidebar, no player, just the auth content
 */
export function AuthLayout() {
	return (
		<div className="flex h-screen overflow-hidden bg-background text-foreground">
			<main className="flex-1 min-h-0 overflow-y-auto">
				<Outlet />
			</main>
		</div>
	);
}
